import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Exclude, Expose } from 'class-transformer';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import { IsBoolean, IsString, IsUUID, MaxLength } from 'class-validator';
import { UserDto } from '../../user/dto/user.dto';
import { JobPhaseBumpDto } from '../../job-phase-bump/dtos/job-phase-bump.dto';
import { JobPhaseBumpInterface } from '../../job-phase-bump/interfaces/job-phase-bump.interface';
import { JobPhaseBumpPaidInterface } from '../interfaces/job-phase-bump-paid.interface';
import { UserPublicInterface } from 'src/modules/user/interfaces/user-public.interface';

@Exclude()
export class JobPhaseBumpPaidDto
  extends CommonEntityDto
  implements JobPhaseBumpPaidInterface
{
  @ApiProperty({
    title: 'Paid',
    type: 'boolean',
  })
  @IsBoolean()
  @Expose()
  paid!: boolean;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated User ID',
  })
  @IsUUID()
  @Expose()
  userId!: string;

  @ApiPropertyOptional({
    type: () => [UserDto],
    title: 'User',
    description: 'The user associated with this job phase bump note.',
  })
  @Expose()
  user?: UserPublicInterface | undefined;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated Job Phase Bump ID',
  })
  @IsUUID()
  @Expose()
  jobPhaseBumpId!: string;

  @ApiPropertyOptional({
    type: () => [JobPhaseBumpDto],
    title: 'Job Phase Bump',
    description: 'The Job Phase Bump associated with this job phase bump note.',
  })
  @Expose()
  jobPhaseBump?: JobPhaseBumpInterface | undefined;
}
